import { RangeSelectElementsAction } from 'js/actionCreators/scribeActions';
import { getProjectById } from 'js/sagas/selectors';
import { getActiveScene } from 'js/shared/helpers/scenesHelpers';
import { ScribeState } from 'js/types';

export function rangeSelectElementsReducer(state: ScribeState, action: RangeSelectElementsAction): ScribeState {
  const { targetElementId, projectId } = action;
  const { lastSelectedElement, activeElements } = state;
  const project = getProjectById({ scribes: state }, projectId);

  if (!project) {
    return state;
  }

  const activeScene = getActiveScene(project);
  if (!activeScene) {
    return state;
  }

  let startIndex = activeScene.elementIds.findIndex(id => id === lastSelectedElement);
  if (startIndex === -1) {
    startIndex = 0;
  }
  const endIndex = activeScene.elementIds.findIndex(id => id === targetElementId);
  if (endIndex === -1) {
    return state;
  }

  const [from, to] = startIndex < endIndex ? [startIndex, endIndex] : [endIndex, startIndex];
  const elementIdsInRange = activeScene.elementIds.slice(from, to + 1);

  return {
    ...state,
    activeElements: Array.from(new Set([...activeElements, ...elementIdsInRange])),
    lastSelectedElement: targetElementId
  };
}
